import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/helpers";
import { ReactNode } from "react";
import { Card } from "../ui/card";
type QRCodeContainerProps = {
  className?: string;
  children: ReactNode;
};
export default function QRCodeContainer(t0) {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("aspect-square size-80 overflow-hidden rounded-5xl p-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <Card className={t1}>{children}</Card>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}